import { Card } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import Portal from '../../../components/Portal';
import PricingModifierTable from '../components/PricingModifierTable';

const PricingModifierList = () => {
  const {
    state: { pageSize }
  } = useContext(AppContext);
  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <span className="portal-header">Quote Modifiers</span>
      </Portal>
      {pageSize && <PricingModifierTable />}
    </Card>
  );
};

export default PricingModifierList;
